export const deleteButtonStyles = {
    button: 'btn btn-icon2 detailBtn delet',
};

export const editButtonStyles = {
    button: 'btn btn-icon2 detailBtn edit',
};

export const modifyButtonStyles = {
    button: 'btn btn-default gray icon modify',
};

export const createdRangeButtonStyles = {
    button: 'btn btn-default line icon range',
};

export const reportBackButtonStyles = {
    button: 'btn btn-default line small',
};
